// extracted by mini-css-extract-plugin
export default {"item":"VBDropdownItem_item__73zRM","big":"VBDropdownItem_big__WD0g2","red":"VBDropdownItem_red__2eybd"};